<script>
import SetupProfile from './SetupProfile.vue'
import MultiSelect from '@/components/registration/MultiSelect.vue'

import { mapGetters } from 'vuex'
import request from '@/utils/request'
export default {
    // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        MultiSelect,
    },
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: SetupProfile, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            section: 'account-info',
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['form']),
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        /**
         * Handle when the form has been submitted
         *
         * @return {void}
         */
        async onSubmit() {
            // validate the form fields
            const result = await this.$validator.validateAll()

            // Check if validation fails
            if (result) {
                this.$store.commit('setLoading', true)

                let registrationUrl = '/customers/face-to-face'
                if (this.$route.meta.publicRegistration === true) {
                    registrationUrl = '/customers/non-face-to-face'
                }

                try {
                    const formData = this.$store.state.registration.form
                    formData.dataSegmentId = this.dataSegmentId

                    const { data } = await request({
                        url: registrationUrl,
                        method: 'post',
                        data: formData,
                    })

                    this.$store.commit('updateField', {
                        key: 'idenfoId',
                        value: data.data.idenfoId,
                    })

                    if (this.$route.meta.publicRegistration === true) {
                        this.$router.push({
                            name: 'public-registration-finish',
                            params: {
                                dataSegmentId: this.dataSegmentId,
                            },
                        })
                    } else {
                        this.$router.push('/register-customer/finish')
                    }
                } catch (errors) {
                    this.$store.commit('setError', errors)
                }
                this.$store.commit('setLoading', false)
            } else {
                this.$store.commit('setError', this.errors.all()[0])
            }
        }, // End of onSubmit() method
    }, // End of Component > methods
} // End of export default
</script>
